import React, { FC } from 'react';
import ImportGridModal from './ImportGridModal';

interface OWFlatfileImporterProps {
	dataLoadComplete: boolean;
	entityName?: string;
	type: string;
	fields: any[];
	data: Record<string, any>[];
	onComplete?: () => void;
	onDataLoad: (result: { validData: any[] }) => Promise<any>;
	recordHook?: (record: any) => any;
	validateRecordsOnSubmit?: (data: any[]) => string | undefined | null | false;
	// Whether the user can add rows in the edit grid. Defaults to true; set false for a fixed
	// row set (e.g. editing a value per existing record).
	allowAddRows?: boolean;
	// Whether the user can delete rows in the edit grid. Defaults to true; set false for a fixed
	// row set where removing a record makes no sense in context.
	allowDeleteRows?: boolean;
}

// Parent owns the open state via `dataLoadComplete` and is expected to flip it
// back to false from its `onComplete` handler. Visibility is derived directly
// from the prop — no local state — so the modal renders correctly on first
// paint when `dataLoadComplete` arrives true.
const OWFlatfileImporter: FC<OWFlatfileImporterProps> = ({
	dataLoadComplete,
	entityName,
	type,
	fields,
	data,
	onComplete,
	onDataLoad,
	recordHook,
	validateRecordsOnSubmit,
	allowAddRows = true,
	allowDeleteRows = true,
}) => {
	if (!dataLoadComplete) return null;

	const handleClose = () => {
		if (onComplete) onComplete();
	};

	return (
		<ImportGridModal
			visible
			title={`Edit ${entityName || type}`}
			fields={fields}
			initialData={data}
			skipUpload
			recordHook={recordHook}
			validateRecordsOnSubmit={validateRecordsOnSubmit}
			allowAddRows={allowAddRows}
			allowDeleteRows={allowDeleteRows}
			onDataLoad={onDataLoad}
			onCancel={handleClose}
			onComplete={handleClose}
		/>
	);
};

export default OWFlatfileImporter;
